import axios from '~/utils/axios';
import { Balance } from '~/types/account';

export type ReportAccount = {
  id: string;
  number: string;
  alias?: string;
  balances: Balance[];
};

export type PartnersReportEntry = { partnerId: string; name: string; accounts: ReportAccount[] };
export type TenantAccountsReportEntry = {
  productId: string;
  productName: string;
  accounts: ReportAccount[];
};

export const getPartnersReport = () =>
  axios.get<PartnersReportEntry[]>('/partnersReport').then((res) => res.data);

export const getTenantAccountsReport = () =>
  axios.get<TenantAccountsReportEntry[]>('/tenantAccountsReport').then((res) => res.data);
